module.exports = function() {
  return new Worker(__webpack_public_path__ + "465cc37f08706f534ed3.worker.js");
};